<template>
	<div class="top_search">
		<div class="search_channel">
			<div class="top_channel_box">
				<a v-for="item in list" :key="item.id" :href="PAGE_BASE_URL+item.url" :target="item.id==cid?'':'_blank'" class="top_channel_cell" >
					<div class="top_channel_title">{{item.title}}</div>
					<div :class="item.id==cid?'top_channel_border_on':'top_channel_border'"></div>
				</a>
			</div>
			<!-- <div class="top_search_box">
				<div class="search_input_box">
					<Input class="search_input" prefix="ios-search" v-model="keyword" :border="false" placeholder="关键词" />
				</div>
				<div class="search_btn">搜索</div>
			</div> -->
		</div>
	</div>
</template>
<script>
	export default {
		data (){
			return {
				keyword:'',
				list:[{
					id:1,
					title:"首页",
					url:'/'
				},{
					id:2,
					title:"资讯",
					url:'/secondarypage/2'
				},{
					id:3,
					title:"评测",
					url:'/secondarypage/3'
				},{
					id:4,
					title:"直播",
					url:'/livelist/4'
				},{
					id:5,
					title:"商城",
					url:'/secondarypage/5'
				},{
					id:6,
					title:"应用",
					url:'/secondarypage/6'
				}],
				PAGE_BASE_URL:''
			}
		},
		props:['cid'],
		created (){
			this.PAGE_BASE_URL=window.location.origin
			if(this.cid>1){
				let item = this.list.find(item => item.id == this.cid);
				if (item) {
					document.title = item.title;
				} else {
					document.title = '汽车时间_属于你的汽车时间_motortime.com';
				}
			}

		},
		methods:{

		}
	}
</script>
<style lang="scss">
	.top_search{
		width: 100%;
		height: 85px;
		width: 100%;
		background-color:#F8F8F8;
		display: flex;
		align-items:center;
		justify-content: center;
		.search_channel{
			width: 1200px;
			display: flex;
			align-items:center;
			.top_channel_box{
				flex: 1;
				display: flex;
				align-items:center;
			}
			.top_channel_title{
				color: #333333;
				font-size: 21px;
				cursor: pointer;
				padding:0 16px;
				border-bottom:5px solid #F8F8F8;
			}
			.top_channel_border_on{
				width: 17px;
				height: 5px;
				background-color: #333333;
				border-radius: 3px;
				margin: 0 auto;
			}
			.top_channel_border{
				width: 17px;
				height: 5px;
			}
			.top_search_box{
				display: flex;
				align-items:center;
				.search_input_box{
					height: 39px;
					display: flex;
					display: flex;
					align-items:center;
					background-color: #ffffff;
					.search_input{
						width: 305px;
						height: 39px;
					}
					input{
						height: 39px !important;
						border-radius: 0 !important;
					}
					.ivu-input-prefix{
						display: flex;
						align-items:center;
						justify-content:center;
						height: 39px !important;
					}
				}
				.search_btn{
					width: 71px;
					height: 39px;
					display: flex;
					align-items:center;
					justify-content:center;
					color: #ffffff;
					font-size: 15px;
					cursor: pointer;
					background-color: #FFBB00;
				}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/topSearch.vue